export const permissionMatrix = [
  "canRead",
  "canWrite",
  "canApproval",
  "canAdmin",
  "canViewAll",
];
// "1-read", "2-write", "4-approval", "8-admin", "16:viewAll"

export const decodeAccessLevelCode = (accessCode) => {
  const decode = accessCode
    .toString(2)
    .padStart(permissionMatrix.length, "0")
    .split("");
  let accessLevel = {
    canRead: false,
    canWrite: false,
    canApprove: false,
    canViewAll: false,
    canAdmin: false,
  };
  permissionMatrix.reverse().forEach((item, index) => {
    accessLevel[item] = !!Number(decode[index]);
  });
  return accessLevel;
};
